import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { em } from "@util/convertUnits";

import { navDataWide, navDataMobile } from "./navigation.data";

import NavBarMobile from "./NavBarMobile";
import NavBarWide from "./NavBarWide";

const NavBar = ({ bp }) => {
  const listCss = css`
    flex-wrap: nowrap;
    justify-content: center;
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
  `;

  const wrapNavWide = css(`
    display: none;
    @media (min-width: ${em(bp, 16)}) {
      display: block;
    }
  `);

  const wrapNavMobile = css(`

    @media (min-width: ${em(bp, 16)}) {
      display: none;
    }
  `);

  return (
    <nav className="flex-grow-1">
      {/* Wide Nav */}
      <div css={wrapNavWide}>
        <ul css={listCss}>
          <NavBarWide navData={navDataWide} />
        </ul>
      </div>

      {/* Mobile Nav */}
      <div css={wrapNavMobile}>
        <NavBarMobile navData={navDataMobile} />
      </div>
    </nav>
  );
};

NavBar.propTypes = {
  bp: PropTypes.number,
};

export default NavBar;
